import { findTokens } from "./parser"

export type TokenLookup = (name: string) => string | undefined
export type OnMissingToken = (name: string) => void

/**
 * Substitutes [[token-name]] placeholders in input with values from lookup.
 * Single-pass: token values containing further placeholders are NOT recursively expanded.
 *
 * carrot-app ports this in Carrot.Content/Utilities/TextTokenSubstitution.cs; change both together.
 */
export function resolveTokens(input: string, lookup: TokenLookup, onMissing?: OnMissingToken): string {
  if (!input) return input
  const matches = findTokens(input)
  if (matches.length === 0) return input

  let result = ""
  let cursor = 0
  for (const { name, start, end } of matches) {
    result += input.slice(cursor, start)
    const value = lookup(name)
    if (value === undefined) {
      onMissing?.(name)
      result += input.slice(start, end)
    } else {
      result += value
    }
    cursor = end
  }
  result += input.slice(cursor)
  return result
}
